import { gql } from "@apollo/client";

export const GET_WINE_CLUBS = gql`
	query GetWineClubs {
		wineClubs {
			nodes {
				name
				id
				price
				bottles
				frequency
			}
		}
	}
`;

export const GET_WINE_CLUB = gql`
	query GetWineClub($id: UUID!) {
		wineClub(id: $id) {
			bottles
			name
			description
			frequency
			price
			shippingMonths {
				nodes {
					id
					monthName
					monthNumber
					monthOrder
				}
			}
			wineClubProducts {
				nodes {
					quantity
					variantId
				}
			}
			wineClubType
		}
	}
`;

export const CREATE_SUBSCRIPTION_BOOKING = gql`
	mutation CreateCustomerBooking($customerBooking: CustomerBookingInput!) {
		createCustomerBooking(input: { customerBooking: $customerBooking }) {
			clientMutationId
		}
	}
`;
